import React from 'react';
import { observer } from 'mobx-react-lite';
import { Button } from 'primereact/button';

export interface MatenSuccessProps {
    title?: string;
    message?: string;
    hint?: string;
    showButton?: boolean;
    buttonLabel?: string;
    buttonIcon?: string;
    onButtonClick?: () => void;
    buttonLink?: string;
    targetBlank?: boolean;
    maxWidth?: string;
    minHeight?: string;
    className?: string;
    testId?: string;
}

const MatenSuccess = observer(
    ({
        title = 'Erfolgreich abgeschlossen',
        message = 'Die Aktion wurde erfolgreich durchgeführt.',
        hint,
        showButton = false,
        buttonLabel = 'Weiter',
        buttonIcon = 'pi pi-arrow-right',
        onButtonClick,
        buttonLink,
        targetBlank = true,
        maxWidth = '400px',
        minHeight = '100vh',
        className = '',
        testId = 'maten-success',
    }: MatenSuccessProps) => {
        const handleButtonClick = () => {
            if (buttonLink) {
                window.open(buttonLink, targetBlank ? '_blank' : '_self');
            } else if (onButtonClick) {
                onButtonClick();
            }
        };

        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight,
                    padding: '20px',
                }}
                className={className}
                data-testid={testId}
            >
                <div
                    style={{
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '40px 32px',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                        textAlign: 'center',
                        maxWidth,
                        width: '100%',
                    }}
                >
                    <div
                        style={{
                            marginBottom: '24px',
                        }}
                    >
                        <div
                            style={{
                                width: '48px',
                                height: '48px',
                                backgroundColor: '#4caf50',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                margin: '0 auto 16px auto',
                            }}
                        >
                            <i
                                className="pi pi-check-circle"
                                style={{
                                    fontSize: '24px',
                                    color: 'white',
                                }}
                            ></i>
                        </div>
                        <h1
                            style={{
                                fontSize: '24px',
                                fontWeight: '600',
                                color: '#2c3e50',
                                margin: '0 0 16px 0',
                            }}
                            data-testid={`${testId}-title`}
                        >
                            {title}
                        </h1>
                        <p
                            style={{
                                fontSize: '16px',
                                color: '#474b4bff',
                                lineHeight: '1.5',
                                margin: '0',
                            }}
                            data-testid={`${testId}-message`}
                        >
                            {message}
                        </p>
                    </div>

                    {(showButton || buttonLink || onButtonClick) && (
                        <Button
                            label={buttonLabel}
                            icon={buttonIcon}
                            style={{
                                width: '100%',
                                backgroundColor: '#4caf50',
                                borderColor: '#4caf50',
                                color: 'white',
                                fontWeight: '600',
                                fontSize: '16px',
                                padding: '14px 24px',
                                borderRadius: '8px',
                                border: 'none',
                                marginBottom: hint ? '16px' : '0',
                            }}
                            onClick={handleButtonClick}
                            data-testid={`${testId}-button`}
                        />
                    )}

                    {hint && (
                        <>
                            <div
                                style={{
                                    width: '100%',
                                    height: '1px',
                                    backgroundColor: '#e9ecef',
                                    margin: '20px 0 16px 0',
                                }}
                            ></div>
                            <p
                                style={{
                                    fontSize: '14px',
                                    color: '#95a5a6',
                                    margin: '0',
                                    lineHeight: '1.4',
                                }}
                            >
                                {hint}
                            </p>
                        </>
                    )}
                </div>
            </div>
        );
    }
);

export default MatenSuccess;
